import { createReducer } from '../../app/common/util/reducerUtil';
import { 
  ASYNC_ACTION_START,
  ASYNC_ACTION_FINISH, 
  ASYNC_ACTION_ERROR 
} from './asyncConstants';

const initialState = {
  loading: false,
};

export const asyncActionStarted = (state, payload) => {
  return {
    ...state,
    loading: true,
    message: payload.message,
    show: payload.show,
    key: payload.key,
    error: payload.error,
  }
};

export const asyncActionFinished = (state, payload) => {
  return {
    ...state,
    loading: false,
    error: payload.error,
  }
};

export const asyncActionError = (state, payload) => {
  return {
    ...state,
    loading: false,
    error: payload.error,
  }
};

export default createReducer(initialState, {
  [ASYNC_ACTION_START]: asyncActionStarted,
  [ASYNC_ACTION_FINISH]: asyncActionFinished,
  [ASYNC_ACTION_ERROR]: asyncActionError,
});